{
  "verificationPage": {
    "verify": "Verify",
    "resend": "Resend",
    "resendPush": "Resend Push Notification",
    "sendSms": "Send SMS"
  },
  "options": {
    "selectMethod": "Please select which method you would like to use",
    "inputCode": "Please input the code sent to your device",
    "inputCodeAuthy": "Please input the code from the Authy app from your registered device"
  },
  "info": {
    "verificationCodeSend": "Verification Code Sent to",
    "approvedSuccess": "Successfully Approved Beneficiary",
    "shareSuccess": "Successfully Shared Selected Beneficiaries"
  },
  "errors": {
    "tryAgain": "Please try again. If the problem persists, please contact Client Services.",
    "codeUnexpectedError": "Unexpected Error Occurred Sending Code To Your Device",
    "incorrectCode": "Incorrect verification code",
    "approveError": "Unexpected Error Occurred Sending Approving your Beneficiary",
    "shareError": "Unexpected Error Occurred Sharing your Beneficiary"
  }
}
